<template>
  <div v-show="this.show">
    <div @mousewheel.prevent @click.self="close" class="seal-modal"></div>
    <div class="seal-dialog">
      <div class="top">
        <span class="title">意愿认证</span>
        <span @click="close" class="closeIcon">x</span>
      </div>
      <div class="body-modal" v-if="showLoading">
        <div class="load-box">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            width="40px"
            height="40px"
            viewBox="0 0 50 50"
            style="enable-background: new 0 0 50 50;"
            xml:space="preserve"
          >
            <path
              fill="#409eff"
              d="M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z"
              transform="rotate(275.098 25 25)"
            >
              <animateTransform
                attributeType="xml"
                attributeName="transform"
                type="rotate"
                from="0 25 25"
                to="360 25 25"
                dur="0.6s"
                repeatCount="indefinite"
              ></animateTransform>
            </path>
          </svg>
        </div>
      </div>
      <div class="body" v-if="!isFinish">
        <div class="body-title">意愿认证</div>
        <div v-if="type == 'phone'">
          <div class="body-content">
            <div class="content-text">手机号</div>
            <input
              class="number-input"
              type="number"
              v-model="phoneNumber"
              disabled="true"
            />
          </div>
          <div class="body-content">
            <div class="content-text">验证码</div>
            <input
              class="code-input"
              placeholder="请输入验证码，必填"
              type="text"
              maxlength="15"
              v-model="code"
            />
            <div class="code-button" @click="sendMessage">
              {{ text }}{{ count > 0 ? "(" + count + ")" : "" }}
            </div>
            <div class="nocode" v-if="noCode">请输入验证码</div>
          </div>
        </div>
        <div v-if="type == 'password'">
          <div class="body-content">
            <div class="content-text">签署密码</div>
            <input
              class="password-input"
              type="password"
              placeholder="请输入签署密码，必填"
              v-model="password"
            />
            <div class="nocode" v-if="noPassword">请输入密码</div>
          </div>
        </div>
        <button class="comfirm" @click="reComfirm">确认</button>
        <div class="body-content">
          <span class="ohter">其他认证方式：</span>
          <span
            class="comfirm-type"
            v-if="type != 'password'"
            @click="changeType('password')"
            >密码认证</span
          >
          <span
            class="comfirm-type"
            v-if="type != 'phone'"
            @click="changeType('phone')"
            >短信认证</span
          >
        </div>
      </div>
      <div class="finish-body" v-if="isFinish">
        <div v-if="isSuccess">
          <div class="check-icon_succ-pp-deal"></div>
          <div class="purpose">意愿认证已完成</div>
          <div class="check-btn" @click="close">
            确定{{ number > 0 ? "(" + number + ")" : "" }}
          </div>
        </div>
        <div v-else>
          <div class="check-icon-pp-deal"></div>
          <div class="purpose">意愿认证失败</div>
          <div class="again-btn" @click="checkagain">重新认证</div>
        </div>
      </div>
      <div class="foot">
        <div class="foot-contain">
          <div class="icon"></div>
          <span>本次认证服务由e签宝提供</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  /* eslint-disable */
export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      type: "phone",
      isFinish: false,
      isSuccess: true,
      checkRes: false,
      // todo 验证结果画面
      phoneNumber: handler.userInfo.mobile,
      password: "",
      code: "",
      number: 0,
      count: 0,
      text: "获取验证码",
      uuid: "",
      kaptchaId: "",
      loginId: "",
      recordId: "",
      noCode: false,
      noPassword: false,
      showLoading: false,
    }
  },

  methods: {
    close: function () {
      this.isFinish = false
      this.$parent.showPurpose = false
    },
    checkagain: function name() {
      this.isFinish = false
    },
    sendMessage: function () {
      var that = this
      if (this.count > 0) return
      this.uuid = ""
      this.reGetCode()
      this.count = 60
      this.text = "重新获取"
      var timer = setInterval(function () {
        if (that.count > 0) {
          that.count--
        } else {
          clearInterval(timer)
        }
      }, 1000)
    },
    //发送验证码
    reGetCode: function () {
      var that = this
      $.ajax({
        url: handler.severUrl + "/V1/authentication/sendSMSKaptcha",
        type: "post",
        headers: {
          "Content-Type": "application/json;charset=utf8",
          "x-timevale-project-id": "1000000",
          "x-timevale-signature":
            "c054b2215990b107b7e0abc7a9b1a3e057ec79f424a7a809e3598e59191e59e0",
        },
        data: JSON.stringify({
          accountId: handler.userInfo.id,
          accountType: 1,
          mobile: handler.userInfo.mobile,
          projectId: 1000000,
        }),
        success: function (data) {
          that.kaptchaId = data.data.kaptchaId
        },
        error: function (data) {
          console.log("error")
        },
      })
    },

    reComfirmByPhone: function () {
      this.showLoading = true
      var that = this
      $.ajax({
        url: handler.severUrl + "/V1/authentication/validateAuthWithCode",
        type: "post",
        headers: {
          "Content-Type": "application/json;charset=utf8",
          "x-timevale-project-id": "1000000",
          "x-timevale-signature":
            "c054b2215990b107b7e0abc7a9b1a3e057ec79f424a7a809e3598e59191e59e0",
        },
        data: JSON.stringify({
          accountUniqueId: handler.userInfo.uniqueId,
          authId: "4e2e7a34-86f9-4b37-b32d-dfe0309b6376", //写死
          authInfo: {
            authValue: "",
            fileKey: "",
            fileMD5: "",
            fingerValue: "",
            identityCode: that.code, //短信验证码
            kaptchaId: that.kaptchaId, //发短信返回的值
            mobile: handler.userInfo.mobile, //手机号
            password: "",
            serialNo: "",
            type: 0,
          },
          code: "",
          loginFromBackend: 0,
          recordId: "",
        }),
        success: function (data) {
          that.showLoading = false
          that.isFinish = true
          if (data.errCode == 0) {
            that.loginId = data.data.loginId
            that.recordId = data.data.recordId
            that.$parent.authRecordId = data.data.recordId
            that.isSuccess = true
            that.number = 3
            var timer = setInterval(function () {
              if (that.number > 0) {
                that.number--
              } else {
                that.close()
                clearInterval(timer)
              }
            }, 1000)
            that.$emit("check-succ", that.recordId)
          } else {
            that.isSuccess = false
          }
        },
        error: function (data) {
          that.showLoading = false
          console.log("error")
        },
      })
    },
    reComfirmByPassword: function () {
      this.showLoading = true
      var that = this
      $.ajax({
        url: handler.severUrl + "/V1/authentication/validateAuth",
        type: "post",
        headers: {
          "Content-Type": "application/json;charset=utf8",
          "x-timevale-project-id": "1000000",
          "x-timevale-signature":
            "c054b2215990b107b7e0abc7a9b1a3e057ec79f424a7a809e3598e59191e59e0",
        },
        data: JSON.stringify({
          accountUniqueId: handler.userInfo.uniqueId,
          authId: "bde97a46-c538-47c1-9246-a7b131bb547f",
          authInfo: {
            authValue: "",
            fileKey: "",
            fileMD5: "",
            fingerValue: "",
            identityCode: "",
            kaptchaId: "",
            mobile: handler.userInfo.mobile,
            password: CryptoJS.MD5(that.password + "").toString(
              CryptoJS.enc.Hex
            ),
            serialNo: "",
            type: 0,
          },
        }),
        success: function (data) {
          that.showLoading = false
          that.isFinish = true
          if (data.errCode == 0) {
            that.loginId = data.data.loginId
            that.recordId = data.data.recordId
            that.$parent.authRecordId = data.data.recordId
            that.isSuccess = true
            that.number = 3
            var timer = setInterval(function () {
              if (that.number > 0) {
                that.number--
              } else {
                that.close()
                clearInterval(timer)
              }
            }, 1000)
            that.$emit("check-succ", that.recordId) //父组件将所有签章改为可验签，并提交签署
          } else {
            that.isSuccess = false
          }
        },
        error: function (data) {
          that.showLoading = false
          console.log("error")
        },
      })
    },
    reComfirm: function () {
      var that = this
      if (this.type === "phone") {
        if (!this.code) {
          this.noCode = true
          setTimeout(function () {
            that.noCode = false
          }, 3000)
          return
        }
        this.reComfirmByPhone()
      } else if (this.type === "password") {
        if (!this.password) {
          this.noPassword = true
          setTimeout(function () {
            that.noPassword = false
          }, 3000)
          return
        }
        this.reComfirmByPassword()
      }
    },
    changeType: function (type) {
      this.type = type
    },
  }
}
</script>
<style scoped>
.seal-modal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: #000000;
  opacity: 0.5;
  z-index: 9999;
}
.seal-dialog {
  position: fixed;
  top: calc(50% - 220px);
  left: calc(50% - 338px);
  width: 676px;
  height: 440px;
  background-color: #fff;
  z-index: 9999;
}
.seal-dialog .top {
  position: relative;
  width: 100%;
  height: 50px;
  border-bottom: 1px solid #e8e8e8;
}
.seal-dialog .top span {
  position: absolute;
  line-height: 50px;
}
.seal-dialog .top .title {
  left: 24px;
  font-size: 16px;
  font-weight: bold;
  color: #333333;
}
.seal-dialog .top .closeIcon {
  right: 24px;
  font-size: 18px;
  color: #bfbfbf;
  cursor: pointer;
}
.body-content {
  position: relative;
  width: 340px;
  margin: 0 auto;
  margin-top: 20px;
}
.number-input {
  margin-top: 10px;
}
.content-text {
  color: #cccccc;
}
.foot {
  height: 32px;
  background-color: #f7f8fa;
  position: absolute;
  bottom: 0;
  width: 100%;
}
.foot-contain {
  width: 180px;
  margin: 0 auto;
}
.foot span {
  position: relative;
  width: 139px;
  height: 17px;
  font-size: 12px;
  font-family: PingFangSC-Regular;
  color: #999999;
  letter-spacing: 0;
  text-align: center;
  margin-left: calc(50% - 70px);
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

input[type="number"] {
  -moz-appearance: textfield;
}
input {
  width: 363px;
  height: 32px;
  background: #f5f5f5;
  border: 1px solid #e4e4e4;
  outline: none;
  border-radius: 3px;
}
.password-input {
  margin-top: 10px;
  background: #ffffff;
}
.code {
  background: #ffffff;
  width: 292px;
  border-radius: 3px 0px 0px 3px;
}
.icon {
  position: relative;
  display: inline-block;
  width: 16px;
  height: 16px;
  background-size: 100% 100%;
  top: 4px;
  left: 20px;

  background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAiCAYAAAA+stv/AAABEklEQVRYR+1Xu4qEMBQ9qcRHozaCooKFIH6Bv61fIFjYW1mIlSCIu6iFFurgFIEtdtmsGWaLpLtw783hPAIhePMhaZqe78JACPkQAAQD/5MBVVURBAENxzAM6LqO1rZtwzRNpvDUdY11Xb/MfJsCwzCQJAltbtsWVVXROo5j+L7PBCDPc0zTJADwYUCWZUiSxCTBRf9xHHwAMN38Q/OfTSgARFEE13WZiCiKAvM88/GAeAfCMITjOEwSlGWJZVn4SMB0s4jhKxjQNA3Xc8xyxnHEvu98PCBi+HIGFEWB53lUr0u/vu9pbVkWdF1nsQCapsG2bb/zANPmG83iZyQYeDKQZdl4w0e3Rs/z/CS3NnAYfgDQ81BfvE/PkgAAAABJRU5ErkJggg==");
}
.body-title {
  width: 200px;
  margin: 0 auto;
  text-align: center;
  font-size: 16px;
  margin-top: 20px;
}
.code-input {
  margin-top: 10px;
  background: #ffffff;
}
.code-button {
  cursor: pointer;
  color: #606266;
  position: absolute;
  display: inline-block;
  width: 120px;
  right: -28px;
  top: 37px;
  z-index: 99;
  text-align: center;
  border-left: solid 1px #e4e4e4;
}
.comfirm {
  margin-top: 20px;
  margin-left: calc(50% - 67px);
  color: #ffffff;
  border: none;
  background: #e33e33;
  cursor: pointer;
  width: 135px;
  height: 40px;
  border-radius: 3px;
}
.ohter {
  color: #606266;
}
.comfirm-type {
  cursor: pointer;
  color: #0084ff;
}

.purpose {
  width: 20%;
  margin: 0 auto;
  text-align: center;
  margin-top: 40px;
  font-family: PingFangSC-Regular;
  font-size: 16px;
  color: #4d4d4d;
}
.check-btn {
  background-color: #fff;
  color: #666666;
  border: 1px solid #d9d9d9;
  margin: 0 auto;
  margin-top: 20px;
  width: 80px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  border-radius: 1px;
  cursor: pointer;
}
.again-btn {
  background-color: #0975e0;
  color: #ffffff;
  border-radius: 3px;
  margin: 0 auto;
  margin-top: 20px;
  width: 90px;
  height: 30px;
  text-align: center;
  line-height: 30px;
  cursor: pointer;
}
.nocode {
  font-size: 14px;
  color: #e33e33;
}
.body-modal {
  z-index: 9999;
  background-color: rgba(0, 0, 0, 0.3);
  position: absolute;
  top: 50px;
  bottom: 32px;
  width: 100%;
}
.load-box {
  position: absolute;
  width: 40px;
  height: 40px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
